module.exports = __webpack_public_path__ + "static/media/turing.fa2d52fc.png";